/* globals Forms, Helpers, Editor, ErrorHandler, location */
'use strict'

import 'common'
import 'lib/forms'
import 'lib/helpers'
import 'lib/geocomplete'
import 'lib/error_handlers'

// Wizard
import 'lib/attachments'
import 'lib/skills'
import 'lib/editor'
import { registerContext } from 'utils'

registerContext(require.context('portal_components', true, /(\.(js))?\.jsx$/))

$(function () {
  Forms.initForm()
  Helpers.initHoverDropdowns()
  Editor.initEditor()

  $(document).on('click', '.sign-in-popup', function (e) {
    e.preventDefault()
    window.open(this.href, 'sign-in-popup', 'width=500,height=500,resizable=yes,scrollbars=yes')
  })
  $(document).on('ajaxError', function (event, response) {
    ErrorHandler.handleAnyAjaxError(event, response)
  })

  function scrollToAnchor (anchor) {
    const topOffset = $(anchor).offset().top - ($('.primary-menu').height() || 0)
    $([document.documentElement, document.body]).animate({
      scrollTop: topOffset
    }, 1000)
  }

  if (location.hash === '#job-ads') scrollToAnchor('main#job-ads')

  $('.anchor-link').on('click', function (e) {
    const linkHref = $(this).attr('href')
    const anchor = `#${linkHref.split('#')[1]}`
    if (location.href + anchor === linkHref || location.hash === anchor) {
      e.preventDefault()
      scrollToAnchor($(anchor))
    }
  })
})
